import {useEffect, useMemo} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {getRandomConsultant} from "@pg-rp/consultants";

import {leadModalZindex} from "../../../application/constants/lead/lead_modal_zindex";
import {HotlinePhoneButton} from "../../../atoms/HotlinePhoneButton";
import {useGetPropertyDetailQuery} from "../../../property/api/get_property_detail";
import {useAppSelector} from "../../../store/hooks";
import {AmplitudeHotlineConsultantButtonName, trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {trackAmplitudeViewModal} from "../../../tracking/amplitude/track_amplitude_view_modal";
import {getAmplitudeScreenLocation} from "../../../user/tracking/track_amplitude_phone_verified";
import {UnlockChoiceModalPriceHeader} from "./unlock_choice_modal/UnlockChoiceModalPriceHeader";

interface IProps {
    onShowSimilar: () => void;
    onClose: () => void;
}

// Shown instead of the lead steps for a compass offer - its vendor takes no leads, so the user gets our hotline number
export const HotlineConsultantStep = ({onShowSimilar, onClose}: IProps) => {
    const flowState = useAppSelector((state) => state.registrationFlow);
    const viewType = useAppSelector((state) => state.viewType.current);
    const pageProperty = useAppSelector((state) => state.property.property);
    const isPageProperty = Boolean(pageProperty && pageProperty.id === flowState.propertyId);
    const {data: fetchedPropertyData} = useGetPropertyDetailQuery(flowState.propertyId as number, {skip: !flowState.propertyId || isPageProperty});
    const propertyData = isPageProperty ? pageProperty : fetchedPropertyData;
    const consultant = useMemo(() => getRandomConsultant(), []);
    const price =
        propertyData?.price && propertyData.price_m2
            ? {price: propertyData.price, priceM2: propertyData.price_m2, currency: propertyData.offer.currency}
            : null;
    const trackingIds = {itemId: flowState.offerId ?? null, propertyId: flowState.propertyId ?? null};

    useEffect(() => {
        trackAmplitudeViewModal({modalName: "rp_hotline_consultant", location: getAmplitudeScreenLocation(viewType), ...trackingIds});
    }, []);

    const trackClick = (buttonName: AmplitudeHotlineConsultantButtonName) => {
        trackAmplitudeButtonClick({buttonName, buttonCategory: "rp_hotline_consultant", ...trackingIds});
    };

    const handleShowSimilar = () => {
        trackClick("rp_hotline_consultant_show_similar");
        onShowSimilar();
    };

    return (
        <ResponsiveModal isOpen onClose={onClose} shouldCloseOnOverlayClick={false} zIndex={leadModalZindex}>
            <ResponsiveModal.Header divider={price !== null} className={price ? priceHeaderStyle : headerStyle}>
                {price && propertyData && <UnlockChoiceModalPriceHeader price={price} offerType={propertyData.offer.type} />}
                <ResponsiveModal.CloseButton className={price ? priceHeaderCloseButtonStyle : undefined} />
            </ResponsiveModal.Header>

            <ResponsiveModal.Body className={bodyStyle}>
                <div className={consultantStyle}>
                    <Image
                        width="128"
                        height="128"
                        src={consultant.image.s144}
                        src2x={consultant.image.s216}
                        alt={consultant.fullName}
                        className={consultantImageStyle}
                    />
                    <Text variant="headline_4" as="p" align="center">
                        {consultant.fullName}
                    </Text>
                    <Text variant="info_txt_1" as="p" align="center" color="var(--colors-gray-800)" mb={2}>
                        Konsultant mieszkaniowy
                    </Text>

                    <HotlinePhoneButton offerId={flowState.offerId ?? null} propertyId={flowState.propertyId} fetchOnMount phoneDisplay="link" />
                </div>

                <Button variant="filled_primary" fullWidth onClick={handleShowSimilar} className={buttonStyle}>
                    Zobacz podobne oferty
                </Button>
            </ResponsiveModal.Body>
        </ResponsiveModal>
    );
};

const priceHeaderStyle = css({
    position: "relative",
    pt: 1.5,
    pb: 3,
    pl: 2,
    pr: 6,
    md: {
        pb: 1.5,
        pl: 3,
        pr: 7
    }
});

const priceHeaderCloseButtonStyle = css({
    position: "absolute",
    top: 1.5,
    right: 2,
    md: {
        right: 3
    }
});

const headerStyle = css({
    display: "flex",
    justifyContent: "flex-end",
    px: 2,
    pt: 1.5,
    md: {
        px: 3
    }
});

const bodyStyle = css({
    px: 2,
    pt: 1.5,
    pb: 3,
    md: {
        px: 3
    }
});

const consultantStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mb: 3
});

const consultantImageStyle = css({
    width: "8.8rem",
    height: "8.8rem",
    borderRadius: "50%",
    border: "0.5rem solid var(--colors-primary)",
    mb: 2,

    "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover"
    }
});

const buttonStyle = css({
    minH: "56px"
});
import {useEffect, useMemo} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {getRandomConsultant} from "@pg-rp/consultants";

import {leadModalZindex} from "../../../application/constants/lead/lead_modal_zindex";
import {HotlinePhoneButton} from "../../../atoms/HotlinePhoneButton";
import {useGetPropertyDetailQuery} from "../../../property/api/get_property_detail";
import {useAppSelector} from "../../../store/hooks";
import {AmplitudeHotlineConsultantButtonName, trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {trackAmplitudeViewModal} from "../../../tracking/amplitude/track_amplitude_view_modal";
import {getAmplitudeScreenLocation} from "../../../user/tracking/track_amplitude_phone_verified";
import {UnlockChoiceModalPriceHeader} from "./unlock_choice_modal/UnlockChoiceModalPriceHeader";

interface IProps {
    onShowSimilar: () => void;
    onClose: () => void;
}

// Shown instead of the lead steps for a compass offer - its vendor takes no leads, so the user gets our hotline number
export const HotlineConsultantStep = ({onShowSimilar, onClose}: IProps) => {
    const flowState = useAppSelector((state) => state.registrationFlow);
    const viewType = useAppSelector((state) => state.viewType.current);
    const pageProperty = useAppSelector((state) => state.property.property);
    const isPageProperty = Boolean(pageProperty && pageProperty.id === flowState.propertyId);
    const {data: fetchedPropertyData} = useGetPropertyDetailQuery(flowState.propertyId as number, {skip: !flowState.propertyId || isPageProperty});
    const propertyData = isPageProperty ? pageProperty : fetchedPropertyData;
    const consultant = useMemo(() => getRandomConsultant(), []);
    const price =
        propertyData?.price && propertyData.price_m2
            ? {price: propertyData.price, priceM2: propertyData.price_m2, currency: propertyData.offer.currency}
            : null;
    const trackingIds = {itemId: flowState.offerId ?? null, propertyId: flowState.propertyId ?? null};

    useEffect(() => {
        trackAmplitudeViewModal({modalName: "rp_hotline_consultant", location: getAmplitudeScreenLocation(viewType), ...trackingIds});
    }, []);

    const trackClick = (buttonName: AmplitudeHotlineConsultantButtonName) => {
        trackAmplitudeButtonClick({buttonName, buttonCategory: "rp_hotline_consultant", ...trackingIds});
    };

    const handleShowSimilar = () => {
        trackClick("rp_hotline_consultant_show_similar");
        onShowSimilar();
    };

    return (
        <ResponsiveModal isOpen onClose={onClose} shouldCloseOnOverlayClick={false} zIndex={leadModalZindex}>
            <ResponsiveModal.Header divider={price !== null} className={price ? priceHeaderStyle : headerStyle}>
                {price && propertyData && <UnlockChoiceModalPriceHeader price={price} offerType={propertyData.offer.type} />}
                <ResponsiveModal.CloseButton className={price ? priceHeaderCloseButtonStyle : undefined} />
            </ResponsiveModal.Header>

            <ResponsiveModal.Body className={bodyStyle}>
                <div className={consultantStyle}>
                    <Image
                        width="128"
                        height="128"
                        src={consultant.image.s144}
                        src2x={consultant.image.s216}
                        alt={consultant.fullName}
                        className={consultantImageStyle}
                    />
                    <Text variant="headline_4" as="p" align="center">
                        {consultant.fullName}
                    </Text>
                    <Text variant="info_txt_1" as="p" align="center" color="var(--colors-gray-800)" mb={2}>
                        Konsultant mieszkaniowy
                    </Text>

                    <HotlinePhoneButton offerId={flowState.offerId ?? null} propertyId={flowState.propertyId} fetchOnMount phoneDisplay="link" />
                </div>

                <Button variant="filled_primary" fullWidth onClick={handleShowSimilar} className={buttonStyle}>
                    Zobacz podobne oferty
                </Button>
            </ResponsiveModal.Body>
        </ResponsiveModal>
    );
};

const priceHeaderStyle = css({
    position: "relative",
    pt: 1.5,
    pb: 3,
    pl: 2,
    pr: 6,
    md: {
        pb: 1.5,
        pl: 3,
        pr: 7
    }
});

const priceHeaderCloseButtonStyle = css({
    position: "absolute",
    top: 1.5,
    right: 2,
    md: {
        right: 3
    }
});

const headerStyle = css({
    display: "flex",
    justifyContent: "flex-end",
    px: 2,
    pt: 1.5,
    md: {
        px: 3
    }
});

const bodyStyle = css({
    px: 2,
    pt: 1.5,
    pb: 3,
    md: {
        px: 3
    }
});

const consultantStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mb: 3
});

const consultantImageStyle = css({
    width: "8.8rem",
    height: "8.8rem",
    borderRadius: "50%",
    border: "0.5rem solid var(--colors-primary)",
    mb: 2,

    "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover"
    }
});

const buttonStyle = css({
    minH: "56px"
});
